import { URLData } from '@telia-common-components/shared';
import React from 'react';
import API from '../../../util/ApiUtil';
import ErrorUtil from '../../../util/ErrorUtil';
import { FetchStatus } from '../../../util/FetchStatus';
export const Go3AppDetailsProvider = (props) => {
    const [go3AppDetailsState, setGo3AppDetailsState] = React.useState({
        status: FetchStatus.UNINITIALIZED,
        data: null
    });
    const urlData = new URLData({ ...props, lang: props.language });
    const commonApi = API(urlData.commonAPIBaseURL, { timeout: 20000 });
    const fetchGo3AppDetails = async () => {
        if (props.data) {
            setGo3AppDetailsState({ status: FetchStatus.FETCHED, data: props.data });
            return;
        }
        try {
            setGo3AppDetailsState({ status: FetchStatus.FETCHING, data: null });
            const { data } = await commonApi.get(`/go3/apps-info?language=${props.language}`);
            setGo3AppDetailsState({ status: FetchStatus.FETCHED, data });
        }
        catch (e) {
            ErrorUtil.pushErrorToTeliaRumAndLog(e);
            setGo3AppDetailsState({ status: FetchStatus.ERROR, data: null });
        }
    };
    const getApp = () => {
        var _a;
        return (_a = go3AppDetailsState.data) === null || _a === void 0 ? void 0 : _a.find((p) => p.productOfferingCode === props.productCode);
    };
    return (React.createElement(Go3AppDetailsContext.Provider, { value: {
            urlData,
            productCode: props.productCode,
            hidePrices: props.hidePrices,
            hideCta: props.hideCta,
            ctaText: props.ctaText,
            tagText: props.tagText,
            customPrice: props.customPrice,
            onCardSelect: props.onCardSelect,
            go3AppDetailsState,
            fetchGo3AppDetails,
            getApp
        } }, props.children));
};
export const Go3AppDetailsContext = React.createContext({
    urlData: null,
    productCode: null,
    hidePrices: false,
    hideCta: false,
    ctaText: null,
    tagText: null,
    customPrice: null,
    onCardSelect: (__productCode) => undefined,
    go3AppDetailsState: undefined,
    fetchGo3AppDetails: () => undefined,
    getApp: () => undefined
});
export const useGo3AppDetails = () => {
    return React.useContext(Go3AppDetailsContext);
};
